// Variables for width calculations
// const canvasHeight = parseInt(document.querySelector('#sheet-canvas').style.height)
// const canvasWidth = parseInt(document.querySelector('#sheet-canvas').style.width)


var addToCartBTN = document.querySelector("#AddToCart")
var addToCartBtn = document.querySelector(".mlveda-custom-add-to-cart");


if(addToCartBTN){
  const form_id = addToCartBTN.closest("form").getAttribute("id");
  const myJobName = document.querySelector(".job-name-input");
  if(myJobName){
    myJobName.setAttribute("form", form_id);
  }
  const quantity_canvas = document.querySelector("input#minimum_quantity");
  const main_product_quantity = document.querySelector(`.quantity-selector__input[form='${form_id}'`)
  if(main_product_quantity){
    quantity_canvas.value = main_product_quantity.getAttribute("value");
  }

  const artwork_select = document.querySelector(".custom-select-mlveda-artwork");
  if(artwork_select){
    artwork_select.setAttribute("form", form_id);
  }
  
  const artwork_select_name = document.querySelector(".artwork-part-name");
  if(artwork_select_name){
    artwork_select_name.setAttribute("form", form_id);
  }

  const artwork_part_num = document.querySelector(".artwork-part-num");
  if(artwork_part_num){
    artwork_part_num.setAttribute("form", form_id);
  }

  const garment_color = document.querySelector("#garment-color");
  if(garment_color){
    garment_color.setAttribute("form", form_id);
  }
}


var devicePixelRatio = window.devicePixelRatio;
var dpi = 72;
setCanvasSize();
// let canvasHeight = 12 * dpi;
// let canvasWidth = 12 * dpi;

var height = parseFloat(
document.querySelector("#sheet-canvas").getAttribute("data-original_height")
);
var width = parseFloat(
  document.querySelector("#sheet-canvas").getAttribute("data-original_width")
);
// const height = parseFloat(
//   document.querySelector("#sheet-canvas").getAttribute("data-original_height")
// );
// const width = parseFloat(
//   document.querySelector("#sheet-canvas").getAttribute("data-original_width")
// );
var canvas_width = parseInt($(".sheet-canvas:visible").width());
var canvas_height = parseInt($(".sheet-canvas:visible").height());

var product = {
  canvas: { width: width, height: height },
  properties: { canvas_width: canvas_width, canvas_height: canvas_height },
};
// document.querySelector("#sheet-canvas").style = "height: "+ canvasHeight +"px; width: "+canvasWidth+"px;"

var totalWidth = product.canvas?.width ?? product.properties?.canvas_width;
var penultimateWidth = Math.ceil(totalWidth - 1);

// Variables for height calculations
var totalHeight = product.canvas?.height ?? product.properties?.canvas_height;
var penultimateHeight = Math.ceil(totalHeight - 1);

// Helper function to create span with styles
function createSpan(classNames, content) {
  const span = document.createElement("span");
  span.className = classNames;
  span.textContent = content;
  return span;
}

// Horizontal ruler
var horizontalRuler = document.createElement("div");
horizontalRuler.className =
  "ruler horizontal-ruler";

for (let i = 0; i <= totalWidth + 1; i++) {
  let width = (penultimateWidth / totalWidth / penultimateWidth) * 100;
  const isLastWidth = i === Math.floor(totalWidth + 1) || i === totalWidth;

  if (i === penultimateWidth) {
    width = ((totalWidth - penultimateWidth) / totalWidth) * 100;
  }
  if (isLastWidth) {
    width = 0;
  }

  const widthDiv = document.createElement("div");
  widthDiv.style.width = `${width}%`;
  widthDiv.className = "h3 horizontal-ruler-block";

  const verticalLine = createSpan(
    "absolute custom-vertical",
    ""
  );
  widthDiv.appendChild(verticalLine);

  const numberLabel = createSpan(
    "flex justify-start text-[9px] absolute -top-4",
    Math.floor(totalWidth + 1) !== i ? i : totalWidth
  );

  if (i === 0) {
    numberLabel.classList.add("-ml-[2px]");
  } else if (i > 0 && i < 10 && !isLastWidth) {
    numberLabel.classList.add("-ml-[1px]");
  } else if (i > 9 && !isLastWidth) {
    numberLabel.classList.add("-ml-[3.5px]");
  } else if (
    isLastWidth &&
    `${totalWidth}`.length === 3 &&
    `${totalWidth}`.includes(".")
  ) {
    numberLabel.classList.add("-ml-[5px]");
  } else if (
    isLastWidth &&
    `${totalWidth}`.length === 5 &&
    `${totalWidth}`.includes(".")
  ) {
    numberLabel.classList.add("-ml-[7.5px]");
  }

  widthDiv.appendChild(numberLabel);
  horizontalRuler.appendChild(widthDiv);
}

// Vertical ruler
var verticalRuler = document.createElement("div");
verticalRuler.className =
  "ruler vertical-ruler absolute left-0 mt-[0.45rem] -ml-5 flex h-full flex-col justify-between border-l";

for (let i = 0; i <= totalHeight + 1; i++) {
  let height = (penultimateHeight / totalHeight / penultimateHeight) * 100;

  if (i === penultimateHeight) {
    height = ((totalHeight - penultimateHeight) / totalHeight) * 100;
  }
  if (i === Math.floor(totalHeight + 1) || i === totalHeight) {
    height = 0;
  }

  const heightDiv = document.createElement("div");
  heightDiv.style.height = `${height}%`;
  heightDiv.className = "relative w-3 vertical-ruler-block";

  const horizontalLine = createSpan(
    "absolute bg-[#E5E7EB] w-4 h-[1px] -mt-1 horizontal-line",
    ""
  );
  heightDiv.appendChild(horizontalLine);

  const numberLabel = createSpan(
    "absolute -left-[2.5rem] -top-[0.75rem] flex w-8 justify-end text-[9px]",
    Math.floor(totalHeight + 1) !== i ? i : totalHeight
  );
  heightDiv.appendChild(numberLabel);

  verticalRuler.appendChild(heightDiv);
}

// file upload section
var canvasImage = document.getElementById("canvasImage");
var previewImage = document.getElementById("previewImage");
var uploadInstructions = document.getElementById("uploadInstructions");
// const canvasHt =
//   parseInt(
//     document.querySelector("#sheet-canvas").getAttribute("data-original_height")
//   ) * 50;
// const canvasWh =
//   parseInt(
//     document.querySelector("#sheet-canvas").getAttribute("data-original_width")
//   ) * 50;

var canvasHt = document
  .querySelector("#sheet-canvas")
  .getAttribute("data-original_height");
var canvasWh = document
  .querySelector("#sheet-canvas")
  .getAttribute("data-original_width");

var ht = devicePixelRatio * 96 * parseFloat(canvasHt);
var wth = devicePixelRatio * 96 * parseFloat(canvasWh);
var calculateWidth = Math.min(1024, wth);
var calculateHeight = (wth / wth) * calculateWidth;
// console.log(calculateWidth, "calculateWidth");
// console.log(calculateHeight, "calculateHeight");
// document.querySelector(
//   "#sheet-canvas"
// ).style = `height: ${calculateHeight}px; width: ${calculateWidth}px`;

// document.querySelector(
//   "#sheet-canvas"
// ).style = `height: ${ht}px; width: ${wth}px`;

// file upload section

// Append to your desired container in the DOM
document.querySelector("#sheet-canvas").appendChild(horizontalRuler);
document.querySelector("#sheet-canvas").appendChild(verticalRuler);
$(".rotate-icon").hide();

document.querySelectorAll("#client_file, #file").forEach((item) => {
  item.addEventListener("change", async function (event) {
    const fileInput = event.target;
    let validated = true;
    const allowedExtensions = [
      "pdf",
      "ai",
      "psd",
      "svg",
      "png",
      "eps",
      "jpg",
      "jpeg",
    ];
    const fileExtension = fileInput.files[0].name
      .split(".")
      .pop()
      .toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      alert(
        "Invalid file type. Accepted file types are: PDF, AI, PSD, SVG, PNG, JPG."
      );
      if (!window.uploadedFile) {
        previewImage.classList.add("hidden-content");
        uploadInstructions.classList.remove("hidden-content");
        // previewImage.classList.add("hidden");
        // uploadInstructions.classList.remove("hidden");
      }
      validated = false;
    }
    console.log(validated, "valid");
    if (validated) {
      validateImage(fileInput.files[0], (isValid) => {
        if (isValid) {
          addToCartBtn.setAttribute("disabled", "true");

          document.querySelector("#fileName").innerText =
            fileInput.files[0].name;
            og_client_file = fileInput.files[0];
          document.querySelector("#job-name").value = fileInput.files[0].name.substr(0, 40);
          const formData = new FormData();
          formData.append("file", fileInput.files[0]);
          formData.append("canvasHeight", canvasHt);
          formData.append("canvasWidth", canvasWh);
          formData.append("devicepixelratio", window.devicePixelRatio);

          window.uploadedFile = fileInput.files[0];

          const newFrm = new FormData();
          newFrm.append("file", window.uploadedFile);

          document.querySelector("#progressContainer").style.display = "flex";
          const xhr = new XMLHttpRequest();
          xhr.open(
            "POST",
            "https://apps.613originals.com/api/image",
            true
          );

          // Add an event listener to track upload progress
          // xhr.upload.addEventListener("progress", (e) => {
          //   if (e.lengthComputable) {
          //     const percentComplete = Math.round((e.loaded / e.total) * 100);
          //     const progressCircle = document.querySelector(".progress");
          //     // document.querySelector(
          //     //   ".showProgress"
          //     // ).style.width = `${percentComplete}%`;
          //     const circumference = 2 * Math.PI * 70;
          //     const offset =
          //       circumference - (percentComplete / 100) * circumference;
          //     progressCircle.style.strokeDashoffset = offset;
          //     document.querySelector(
          //       "#upload-progress-text"
          //     ).innerText = `${percentComplete}%`;
          //     // if(percentComplete == 100){
          //     //   document.querySelector(
          //     //   "#upload-progress-text"
          //     // ).innerText = "Rendering.....";
          //     // }
          //   }
          // });

          // Handle successful upload
          // xhr.onloadend = () => {
          //   if (xhr.status === 200) {
          //     document.querySelector("#progressContainer").style.display = "none";
          //     console.log("Hello parser.......");
          //     const response = JSON.parse(xhr.responseText);
          //     console.log("Hello parserDone.......");
          //     previewImage.src = response.data;
          //     // console.log("response.data src: ", response.data);
          //     previewImage.classList.remove("hidden-content");
          //     uploadInstructions.classList.add("hidden-content");
          //     $(".rotate-icon").show();
          //     $("#sheet-canvas").attr("data-orientation", "portrait");
          //     addToCartBtn.removeAttribute("disabled");
          //     // uploadInstructions.classList.add("hidden");
          //     // previewImage.classList.remove("hidden");
          //   } else {
          //     document.querySelector("#progressContainer").style.display = "none";
          //     console.error(`Error: ${xhr.statusText}`);
          //     previewImage.classList.add("hidden-content");
          //     $(".rotate-icon").hide();
          //     // previewImage.classList.add("hidden");
          //     // uploadInstructions.classList.remove("hidden");
          //     uploadInstructions.classList.remove("hidden-content");
          //   }
          //   // document.querySelector(".showProgress").style.width = "0%";
          //   document.querySelector("#upload-progress-text").innerText = `0%`;
          //   document.querySelector(".progress").style.strokeDashoffset =
          //     2 * Math.PI * 70;
          // };

          let uploadStartTime = null;
          let downloadStartTime = null;
          
          // When upload starts
          xhr.upload.onloadstart = (event) => {
            uploadStartTime = new Date().getTime();
            document.getElementById("progressContainer").style.display = "block";
            uploadInstructions.classList.add("hidden-content");
            document.getElementById("upload-status-text").innerHTML = "Uploading Image...";
          };
          
          // Uploading progress
         xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            const now = new Date().getTime();
            const timeElapsed = (now - uploadStartTime) / 1000;
            const loaded = event.loaded;
            const total = event.total;
        
            const percentComplete = Math.round((loaded / total) * 100);
            const uploadSpeed = loaded / timeElapsed;
            const remainingBytes = total - loaded;
            const estimatedTimeLeft = Math.max(Math.round(remainingBytes / uploadSpeed), 1);
            // uploadInstructions.classList.add("hidden-content");
        
            if (percentComplete < 100) {
              document.getElementById("upload-percentage").innerText = `${percentComplete}%`;
              document.getElementById("upload-status-text").innerHTML = `Uploading...`;
              document.getElementById("upload-time-left").innerText = `${estimatedTimeLeft}s left`;
        
              document.getElementById("upload-progress-bar").style.width = `${percentComplete}%`;
            } else {
              // Upload completed
              document.getElementById("upload-percentage").innerText = `0%`;
              document.getElementById("upload-status-text").innerHTML = `Upload Complete!<br> Preparing Image rendering...`;
              document.getElementById("upload-time-left").innerText = ``;
              debugger;
              document.getElementById("upload-progress-bar").style.width = `0%`;
            }
          }
        };

          
          // When uploading done, downloading response
          xhr.onloadstart = (event) => {
            downloadStartTime = new Date().getTime();
            document.getElementById("upload-status-text").innerHTML = "Rendering Image...";
          };
          
          // Downloading response progress
          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              const now = new Date().getTime();
              const timeElapsed = (now - downloadStartTime) / 1000;
              const loaded = event.loaded;
              const total = event.total;
          
              const percentComplete = Math.round((loaded / total) * 100);
              const downloadSpeed = loaded / timeElapsed;
              const remainingBytes = total - loaded;
              const estimatedTimeLeft = Math.max(Math.round(remainingBytes / downloadSpeed), 1);
          
              document.getElementById("upload-percentage").innerText = `${percentComplete}%`;
              document.getElementById("upload-status-text").innerHTML = `Rendering Image...`;
              // document.getElementById("upload-time-left").innerText = `${estimatedTimeLeft}s left`;
              document.getElementById("upload-time-left").innerText = ``;
          
              document.getElementById("upload-progress-bar").style.width = `${percentComplete}%`;
            }
          };
          
          // After everything done
          xhr.onloadend = () => {
            if (xhr.status === 200) {
              document.getElementById("upload-status-text").innerHTML = "Completed!";
              document.getElementById("upload-time-left").innerText = `0s`;

              // console.log("Hello parser.......");
              const response = JSON.parse(xhr.responseText);
              // console.log("Hello parserDone.......");
              previewImage.src = response.data;
              // console.log("response.data src: ", response.data);
              previewImage.classList.remove("hidden-content");
              uploadInstructions.classList.add("hidden-content");
              $(".rotate-icon").show();
              $("#sheet-canvas").attr("data-orientation", "portrait");
              addToCartBtn.removeAttribute("disabled");
              // uploadInstructions.classList.add("hidden");
              // previewImage.classList.remove("hidden");
               document.querySelector("#progressContainer").style.display = "none";
            } else {
              document.getElementById("upload-status-text").innerHTML = "Failed!";
              document.getElementById("upload-time-left").innerText = ``;
            }
          
            setTimeout(() => {
              document.getElementById("progressContainer").style.display = "none";
              document.getElementById("upload-progress-bar").style.width = "0%";
              document.getElementById("upload-percentage").innerText = "0%";
              document.getElementById("upload-time-left").innerText = "";
            }, 1500);
          };

          // Handle errors
          xhr.onerror = () => {
            document.querySelector("#progressContainer").style.display = "none";
            // previewImage.classList.add("hidden");
            previewImage.classList.add("hidden-content");
            $(".rotate-icon").hide();
            // uploadInstructions.classList.remove("hidden");
            uploadInstructions.classList.remove("hidden-content");
            // document.querySelector(".showProgress").style.width = "0%";
            // document.querySelector("#upload-progress-text").innerText = `0%`;
            // document.querySelector(".progress").style.strokeDashoffset =
            //   2 * Math.PI * 70;
            console.warn("An error occurred during the upload.");
            alert("Oops! The file didn't upload, but we're already fixing it. Thanks for your patience!")
          };

          xhr.send(formData);
        } else {
          document.querySelector("#fileName").innerText = "No File Chosen...";
        }
      });
    }
  });
});

function validateImage(file, callback) {
  const maxFileSize = 29 * 1024 * 1024;
  if (file) {
    console.log(file.size, "size");
    if (file.size > maxFileSize) {
      swal.fire({
        width: 600,
        html: `<div style="font-size: 20px;">The uploaded file is large and may take some time to process. You can wait to see the preview, or proceed without the preview if you prefer.
 </div>`,
      });
    }
  }
  return callback(true);
}

// Change canvas color
$(document).on("change", "#garment-color", async function (event) {
  $('label[for="file"].613-labelfile').css("background-color", $("#garment-color option:selected").attr("data-color-code"));
});
$('label[for="file"].613-labelfile').css(
  "background-color",
  $("#garment-color option:selected").attr("data-color-code")
);

// image rotate
// Debounce utility function
// function debounce(func, delay) {
//   let timeout;
//   return function (...args) {
//     clearTimeout(timeout);
//     console.log("cancle");
//     timeout = setTimeout(() => func.apply(this, args), delay);
//   };
// }

// Debounced callApi function
// const debouncedCallApi = () => {
//   var orientation = $("#sheet-canvas").attr("data-orientation");
//   const formData = new FormData();
//   formData.append("file", window.uploadedFile);
//   formData.append("canvasHeight", canvasHt);
//   formData.append("canvasWidth", canvasWh);
//   formData.append("devicepixelratio", window.devicePixelRatio);
//   if (orientation == "portrait" && orientation != "landscape") {
//     formData.append("rotate", "0");
//     // $("#sheet-canvas").attr("data-orientation", "landscape");
//   }
//   if (orientation != "portrait" && orientation == "landscape") {
//     formData.append("rotate", "270");
//     // $("#sheet-canvas").attr("data-orientation", "portrait");
//   }
//   callApi(url, formData, orientation);
// });

// Event listener
// let clicks = 0;
// let initialLayout = "P";
// let finalLayout = "P";
// $(document).on("click", ".rotate-icon", function (event) {
//   addToCartBtn.setAttribute("disabled", "true");
//   const myCanvas = document.querySelector("#sheet-canvas");
//   const myCanvasimg = document.querySelector("#sheet-canvas img");
//   clicks = clicks + 1;
//   if (clicks % 2 == 0) {
//     if (initialLayout == "L") {
//       if (finalLayout == "P") {
//         myCanvasimg.style.transform = "rotate(0deg)";
//       }
//       if (finalLayout == "L") {
//         myCanvasimg.style.transform = "rotate(90deg)";
//       }

//       myCanvas.setAttribute("data-orientation", "portrait");
//       initialLayout = "P";
//     }
//   } else {
//     if (initialLayout == "P") {
//       if (finalLayout == "P") {
//         myCanvasimg.style.transform = "rotate(-90deg)";
//       }

//       if (finalLayout == "L") {
//         myCanvasimg.style.transform = "rotate(0deg)";
//       }

//       myCanvas.setAttribute("data-orientation", "landscape");
//       initialLayout = "L";
//     }
//   }

//   // Trigger API call if there is an uploaded file
//   if (window.uploadedFile) {
//     debouncedCallApi(
//       "https://www.mlveda.com/ShopifyApps/hemlineTest/image/changeImageDimension"
//     );
//   }
// });

$(document).off("click", ".rotate-icon").on("click", ".rotate-icon", function (event) {
  if (window.uploadedFile) {
    $(".rotate-icon").hide();
    addToCartBtn.setAttribute("disabled", "true");
    var orientation = $("#sheet-canvas").attr("data-orientation");
    const formData = new FormData();
    formData.append("file", window.uploadedFile);
    formData.append("canvasHeight", canvasHt);
    formData.append("canvasWidth", canvasWh);
    formData.append("devicepixelratio", window.devicePixelRatio);
    let myAPIUrl= "";
    if (orientation == "portrait" && orientation != "landscape") {
      formData.append("rotate", "270");
      // myAPIUrl = "https://www.mlveda.com/ShopifyApps/613originalTestAPI/image/changeImageDimension";
      myAPIUrl = "https://apps.613originals.com/api/image/changeImageDimension";
      $("#sheet-canvas").attr("data-orientation", "landscape");
    }
    if (orientation != "portrait" && orientation == "landscape") {
      // formData.append("rotate", "0");
      // myAPIUrl = "https://www.mlveda.com/ShopifyApps/613originalTestAPI/image"
      myAPIUrl = "https://apps.613originals.com/api/image"
      $("#sheet-canvas").attr("data-orientation", "portrait");
    }
    callApi(
      myAPIUrl,
      formData
    );
  }
});

// async function callApi(url, formData, orientation) {
//   addToCartBtn.setAttribute("disabled", "true");
//   // document.querySelector("#progressContainer").style.display = "flex";
//   const response = await fetch(url, {
//     method: "POST",
//     body: formData,
//   });

//   if (!response.ok) {
//     // document.querySelector("#progressContainer").style.display = "none";
//     thrownewError(`Error: ${response.statusText}`);
//     previewImage.classList.add("hidden");
//     uploadInstructions.classList.remove("hidden");
//   }
//   const blob = await response.json();
//   previewImage.src = "";
//   previewImage.src = blob.data;
//   console.log("executed.");
//   addToCartBtn.removeAttribute("disabled");

//   document.querySelector("#sheet-canvas img").style.transform = "rotate(0deg)";

//   if (orientation == "portrait") {
//     finalLayout = "P";
//   } else {
//     finalLayout = "L";
//   }

//   previewImage.classList.remove("hidden");
//   uploadInstructions.classList.add("hidden");
//   // document.querySelector("#progressContainer").style.display = "none";
// }

async function callApi(url, formData) {
  // document.querySelector("#progressContainer").style.display = "flex";
  // const response = await fetch(url, {
  //   method: "POST",
  //   body: formData,
  // });

  // if (!response.ok) {
  //   document.querySelector("#progressContainer").style.display = "none";
  //   thrownewError(`Error: ${response.statusText}`);
  //   previewImage.classList.add("hidden");
  //   uploadInstructions.classList.remove("hidden");
  // }
  // const blob = await response.json();
  // previewImage.src = "";
  // previewImage.src = blob.data;

  // previewImage.classList.remove("hidden");
  // uploadInstructions.classList.add("hidden");
  // document.querySelector("#progressContainer").style.display = "none";

  document.querySelector("#progressContainer").style.display = "flex";
  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);

  // // Add an event listener to track upload progress
  // xhr.upload.addEventListener("progress", (e) => {
  //   if (e.lengthComputable) {
  //     const percentComplete = Math.round((e.loaded / e.total) * 100);
  //     const progressCircle = document.querySelector(".progress");
  //     // document.querySelector(
  //     //   ".showProgress"
  //     // ).style.width = `${percentComplete}%`;
  //     const circumference = 2 * Math.PI * 70;
  //     const offset = circumference - (percentComplete / 100) * circumference;
  //     progressCircle.style.strokeDashoffset = offset;
  //     document.querySelector(
  //       "#upload-progress-text"
  //     ).innerText = `${percentComplete}%`;
  //   }
  // });

  // // Handle successful upload
  // xhr.onloadend = () => {
  //   if (xhr.status === 200) {
  //     document.querySelector("#progressContainer").style.display = "none";
  //     const response = JSON.parse(xhr.responseText);
  //     previewImage.src = "";
  //     previewImage.src = response.data;

  //     console.log("response.data src: ", response.data);
  //     // previewImage.classList.remove("hidden");
  //     previewImage.classList.remove("hidden-content");
  //     // uploadInstructions.classList.add("hidden");
  //     uploadInstructions.classList.add("hidden-content");
  //     addToCartBtn.removeAttribute("disabled");

  //     document.querySelector("#progressContainer").style.display = "none";
  //   } else {
  //     document.querySelector("#progressContainer").style.display = "none";
  //     console.error(`Error: ${xhr.statusText}`);
  //     previewImage.classList.add("hidden-content");
  //     // previewImage.classList.add("hidden");
  //     // uploadInstructions.classList.remove("hidden");
  //     uploadInstructions.classList.remove("hidden-content");
  //   }
  //   // document.querySelector(".showProgress").style.width = "0%";
  //   document.querySelector("#upload-progress-text").innerText = `0%`;
  //   document.querySelector(".progress").style.strokeDashoffset =
  //     2 * Math.PI * 70;
  //   $(".rotate-icon").show();
  // };

  // // Handle errors
  // xhr.onerror = () => {
  //   document.querySelector("#progressContainer").style.display = "none";
  //   previewImage.classList.add("hidden-content");
  //   // previewImage.classList.add("hidden");
  //   // uploadInstructions.classList.remove("hidden");
  //   uploadInstructions.classList.remove("hidden-content");
  //   document.querySelector("#upload-progress-text").innerText = `0%`;
  //   document.querySelector(".progress").style.strokeDashoffset =
  //     2 * Math.PI * 70;
  //   console.error("An error occurred during the upload.");
  // };

  // xhr.send(formData);


  // New code
  let uploadStartTime = null;
let downloadStartTime = null;

// When upload starts
xhr.upload.onloadstart = (event) => {
  uploadStartTime = new Date().getTime();
  document.getElementById("progressContainer").style.display = "block";
  uploadInstructions.classList.add("hidden-content");
  document.getElementById("upload-status-text").innerHTML = "Uploading Image...";
};

// Uploading progress
xhr.upload.onprogress = (event) => {
  if (event.lengthComputable) {
    const now = new Date().getTime();
    const timeElapsed = (now - uploadStartTime) / 1000;
    const loaded = event.loaded;
    const total = event.total;

    const percentComplete = Math.round((loaded / total) * 100);
    const uploadSpeed = loaded / timeElapsed;
    const remainingBytes = total - loaded;
    const estimatedTimeLeft = Math.max(Math.round(remainingBytes / uploadSpeed), 1);

    if (percentComplete < 100) {
      document.getElementById("upload-percentage").innerText = `${percentComplete}%`;
      document.getElementById("upload-status-text").innerHTML = `Uploading...`;
      document.getElementById("upload-time-left").innerText = `${estimatedTimeLeft}s left`;

      document.getElementById("upload-progress-bar").style.width = `${percentComplete}%`;
    } else {
      // Upload completed
      document.getElementById("upload-percentage").innerText = `0%`;
      document.getElementById("upload-status-text").innerHTML = `Upload Complete! <br>Preparing Image rendering...`;
      document.getElementById("upload-time-left").innerText = ``;
      document.getElementById("upload-progress-bar").style.width = `0%`;
    }
  }
};

// When uploading done, start downloading response
xhr.onloadstart = (event) => {
  downloadStartTime = new Date().getTime();
  document.getElementById("upload-status-text").innerHTML = "Rendering Image...";
};

// Downloading response progress
xhr.onprogress = (event) => {
  if (event.lengthComputable) {
    const now = new Date().getTime();
    const timeElapsed = (now - downloadStartTime) / 1000;
    const loaded = event.loaded;
    const total = event.total;

    const percentComplete = Math.round((loaded / total) * 100);
    const downloadSpeed = loaded / timeElapsed;
    const remainingBytes = total - loaded;
    const estimatedTimeLeft = Math.max(Math.round(remainingBytes / downloadSpeed), 1);

    document.getElementById("upload-percentage").innerText = `${percentComplete}%`;
    document.getElementById("upload-status-text").innerHTML = `Rendering Image...`;
    document.getElementById("upload-time-left").innerText = ``;

    document.getElementById("upload-progress-bar").style.width = `${percentComplete}%`;
  }
};

// After everything done
xhr.onloadend = () => {
  if (xhr.status === 200) {
    document.getElementById("upload-status-text").innerHTML = "Completed!";
    document.getElementById("upload-time-left").innerText = `0s`;

    const response = JSON.parse(xhr.responseText);
    previewImage.src = response.data;
    previewImage.classList.remove("hidden-content");
    uploadInstructions.classList.add("hidden-content");
    $(".rotate-icon").show();
    $("#sheet-canvas").attr("data-orientation", "portrait");
    addToCartBtn.removeAttribute("disabled");

    document.querySelector("#progressContainer").style.display = "none";
  } else {
    document.getElementById("upload-status-text").innerHTML = "Failed!";
    document.getElementById("upload-time-left").innerText = ``;
  }

  setTimeout(() => {
    document.getElementById("progressContainer").style.display = "none";
    document.getElementById("upload-progress-bar").style.width = "0%";
    document.getElementById("upload-percentage").innerText = "0%";
    document.getElementById("upload-time-left").innerText = "";
  }, 1500);
};

// Handle errors
xhr.onerror = () => {
  document.querySelector("#progressContainer").style.display = "none";
  previewImage.classList.add("hidden-content");
  uploadInstructions.classList.remove("hidden-content");
  document.getElementById("upload-progress-bar").style.width = "0%";
  document.getElementById("upload-percentage").innerText = "0%";
  document.getElementById("upload-time-left").innerText = "";
  console.error("An error occurred during the upload.");
};

xhr.send(formData);

}

// make select 2 boxes
$("#garment-color").select2({
  placeholder: "Select Color",
  allowClear: false,
  // Custom templates for dropdown and selected item
  templateResult: formatColorOption,
  templateSelection: formatColorOption,
});
$("#ink_type").select2({
  placeholder: "Filter by ink...",
  allowClear: false,
  // Custom templates for dropdown and selected item
  templateResult: formatColorOption,
  templateSelection: formatColorOption,
});

$(".custom-select-mlveda").each(function () {
  $(this).select2({
    placeholder: "Filter by ink...",
    allowClear: false,
    // Custom templates for dropdown and selected item
    templateResult: formatColorOption,
    templateSelection: formatColorOption,
  });
});

$(".custom-select-mlveda-artwork").select2({
    placeholder: "Filter by ink...",
    allowClear: false,
});

$(".custom-select-mlveda-artwork").on('change', function (e) {

  // console.log("e: ", e.target.getAttribute("data-title"));
  const my_closest_container = e.target.closest(".sidebar-child-container")
  if(my_closest_container){
    const opts = my_closest_container.querySelectorAll("option")
    let my_new_title = '';
    let my_new_price = '';
    opts.forEach(opt =>{
      if (opt.value == e.target.value) {
        my_new_title = opt.getAttribute("data-title");
        my_new_price = opt.getAttribute("data-price");
        
      }
    })
    my_closest_container.querySelector(".artwork-part-name").value = my_new_title;
    my_closest_container.querySelector(".artwork-price-input").value = my_new_price;
    
  }
});



// Function to format each option
function formatColorOption(option) {
  // Skip placeholder
  if (!option.id) {
    return option.text;
  }

  // Extract color value
  const color = $(option.element).attr("data-color-code");
  const text = option.text;
  if (color == "Filter by ink...") {
    return;
  }
  // Return a color box with the option text
  return $(
    `<div style="display: flex; align-items: center;">
        <span style="display: inline-block; width: 20px; height: 20px; background-color: ${color}; border: 1px solid #ccc; margin-right: 8px; border-radius: 3px;"></span>
        <span>${text}</span>
     </div>`
  );
}
// $(document).on('click',()=>{
//   if(window.uploadedFile){
//     $(".rotate-icon").show()
//   }else{
//     $(".rotate-icon").hide()
//   }
// })

// if(window.uploadedFile){
//     $(".rotate-icon").show()
// }else{
//     $(".rotate-icon").hide()
// }
$(document).on("change", "#showGrid", (e) => {
  if ($("#showGrid").prop("checked")) {
    document.querySelectorAll(".horizontal-line").forEach((item) => {
      item.classList.add("horizontal");
    });
    document.querySelectorAll(".custom-vertical").forEach((item) => {
      item.classList.add("vertical");
    });
    let vheight = $("#sheet-canvas").height() + 10;
    let vwidth = $("#sheet-canvas").width() + 10;

    document.querySelectorAll(".vertical").forEach((item) => {
      item.style = `height: ${vheight}px`;
    });
    document.querySelectorAll(".horizontal").forEach((item) => {
      item.style = `width: ${vwidth}px`;
    });
  } else {
    document.querySelectorAll(".horizontal-line").forEach((item) => {
      item.classList.remove("horizontal");
      item.style = `width: 2rem`;
    });
    document.querySelectorAll(".vertical").forEach((item) => {
      item.style = `height: 2rem`;
    });
    document.querySelectorAll(".custom-vertical").forEach((item) => {
      item.classList.remove("vertical");
    });
    document.querySelectorAll(".horizontal").forEach((item) => {
      item.style = `height: ${vheight}px`;
    });
  }
});
//   if(window.uploadedFile){

document
  .querySelector("#minimum_quantity")
  .addEventListener("input", (event) => {
    const myinputValue = Number(event.target.value);
    const myinputMinValue = Number(event.target.getAttribute("min"));
    if (myinputValue < myinputMinValue) {
      document.querySelector(".quantity-container").classList.add("tool");
      document.querySelector(".quantity-container").style.borderColor =
        "#ff0000";
    } else {
      document.querySelector(".quantity-container").classList.remove("tool");
      document.querySelector(".quantity-container").style.borderColor =
        "rgb(229 231 235 / var(--tw-border-opacity, 1))";
      const main_product_quantity = document.querySelector(`.quantity-selector__input`)
      if(main_product_quantity){
        main_product_quantity.value = myinputValue;
        main_product_quantity.setAttribute('value',myinputValue);
        main_product_quantity.dispatchEvent(new Event("change"));
      }
    }
  });

// Attach a blur event listener to an input
document
  .querySelector("#minimum_quantity")
  .addEventListener("blur", function (event) {
    const myinputValue = Number(event.target.value);
    const myinputMinValue = Number(event.target.getAttribute("min"));

    document.querySelector(".quantity-container").classList.remove("tool");

    if (myinputValue < myinputMinValue) {
      document.querySelector("#minimum_quantity").style.borderColor = "#ff0000";
      document
        .querySelector("#minimum_quantity")
        .setAttribute(
          "title",
          document.querySelector(".quantity-container").getAttribute("data-tip")
        );
    } else {
      document.querySelector("#minimum_quantity").style.borderColor =
        "rgb(229 231 235 / var(--tw-border-opacity, 1))";
      document.querySelector("#minimum_quantity").removeAttribute("title");
    }
  });

// Dynamic add ink button
// document
//   .querySelector(".ink-update-button.plus")
//   .addEventListener("click", () => {
//     // Get the innerHTML of the old select box
//     const oldSelectBox = document.querySelector(".demo-selectbox").innerHTML;
//     const container = document.querySelector(".ink-holder");
//     // Create a new div to hold the select box
//     const mynode = document.createElement("div");
//     mynode.className = "margin-unset custom-ink-container"; // Add necessary class
//     mynode.innerHTML = oldSelectBox; // Set the innerHTML of the new div
//     container.appendChild(mynode); // Append the new div to the container
//     // Initialize select2 on the newly added select box
//     const newSelect = mynode.querySelector(".custom-select-mlveda-demo");
//     const newremoveBtn = mynode.querySelector(".ink-update-button.minus");
//     if (newSelect) {
//       newSelect.classList.add("custom-select-mlveda");
//       newSelect.setAttribute("required", true);
//       $(newSelect).select2({
//         placeholder: "Filter by ink...",
//         allowClear: false,
//         templateResult: formatColorOption,
//         templateSelection: formatColorOption,
//       });
//     } else {
//       console.error("No select box found in the newly created node.");
//     }
//     if (newremoveBtn) {
//       newremoveBtn.addEventListener("click", (e) => {
//         removeInkSelect(e.currentTarget);
//       });
//     } else {
//       console.error("No button found in the newly created node.");
//     }
//   });
// document
//   .querySelectorAll(".ink-update-button.minus")
//   .forEach((deleteButton) => {
//     deleteButton.addEventListener("click", (e) => {
//       removeInkSelect(e.currentTarget);
//     });
//   });
function removeInkSelect(mytarget) {
  const targetNode = mytarget.closest(".margin-unset.custom-ink-container");
  if (targetNode) {
    targetNode.remove();
    console.log("Node removed from DOM.");
  } else {
    console.log("No matching node found.");
  }
}
document
  .querySelector(".save-canvas-details")
  .addEventListener("click", (e) => {
    e.preventDefault();

    const targetBTN = document.querySelector(".save-canvas-details");
    const btn_text = targetBTN.querySelector(".loader-button__text");
        
    const btn_text_loader = targetBTN.querySelector(".loader-button__loader");
    btn_text_loader.removeAttribute("hidden");
    

    
    const jobname = document.querySelector("#job-name");
    const uploadedImage = document.querySelector("#previewImage");
    const quantity = Number(document.querySelector("#minimum_quantity").value);
    const quantityMin = Number(
      document.querySelector("#minimum_quantity").getAttribute("min")
    );


     // console.log("Uplodaded image", uploadedImage);
    if (uploadedImage.getAttribute("src") == "") {
      document
        .querySelector("span.err.file-err")
        .classList.remove("display-none");
      uploadedImage.focus();
      console.log("None")
      return;
    } else {
      document.querySelector("span.err.file-err").classList.add("display-none");
    }

    if (!jobname.value || jobname.value.length > 40) {
      jobname.focus();
      jobname.closest(".sidebar-child-container").querySelector(".info-warning").style.color = '#ff0000';
      return;
    }else{
      jobname.closest(".sidebar-child-container").querySelector(".info-warning").style.color = '#000000';
      
    }
    

    if (quantity < quantityMin) {
      document.querySelector("#minimum_quantity").focus();
      return;
    }

    const imgBase64 = uploadedImage.getAttribute("src");
    const fileName = document.querySelector("#fileName").innerText;

    const formData = new FormData();
    formData.append("file", og_client_file);
    formData.append("cartToken", cartData_token.split("?key")[0]);
    // formData.append("fileName", fileName);
    formData.append("partnumber", part_number);
    formData.append("processedfile", imgBase64);

    console.log("Final form Data: ",formData);

    targetBTN.setAttribute("disabled", "disabled");
    targetBTN.querySelector(".loader-button__text").classList.add("opacity-zero");
    targetBTN.querySelector(".loader-button__loader").classList.remove("opacity-zero");
    targetBTN.querySelector(".loader-button__loader").classList.add("opacity-one");
    targetBTN.setAttribute("aria-busy", "true");
      debugger;
    fetch("https://apps.613originals.com/api/image/fileUploadToAzure", {
        method: "POST",
        body: formData,
      })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((res_data) => {
      // console.log("Upload success:", res_data);
      const file_property = document.querySelectorAll('.product_file');

        Object.entries(res_data).forEach(([key, value], index) => {
          if (file_property[index]) {
            file_property[index].setAttribute("name", `properties[${key}]`);
            file_property[index].setAttribute("value", value);
          }
        });


      

    targetBTN.removeAttribute("disabled", "disabled");
    targetBTN.querySelector(".loader-button__text").classList.remove("opacity-zero");
    targetBTN.querySelector(".loader-button__text").innerHTML = `Details Saved <svg height="20px" width="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 507.2 507.2" xml:space="preserve" fill="#000000" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle style="fill:#32BA7C;" cx="253.6" cy="253.6" r="253.6"></circle> <path style="fill:#0AA06E;" d="M188.8,368l130.4,130.4c108-28.8,188-127.2,188-244.8c0-2.4,0-4.8,0-7.2L404.8,152L188.8,368z"></path> <g> <path style="fill:#FFFFFF;" d="M260,310.4c11.2,11.2,11.2,30.4,0,41.6l-23.2,23.2c-11.2,11.2-30.4,11.2-41.6,0L93.6,272.8 c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L260,310.4z"></path> <path style="fill:#FFFFFF;" d="M348.8,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6l-176,175.2 c-11.2,11.2-30.4,11.2-41.6,0l-23.2-23.2c-11.2-11.2-11.2-30.4,0-41.6L348.8,133.6z"></path> </g> </g></svg> `;
    targetBTN.querySelector(".loader-button__loader").classList.remove("opacity-one");
    targetBTN.querySelector(".loader-button__loader").classList.add("opacity-zero");
    targetBTN.removeAttribute("aria-busy");
      setTimeout(()=>{
        document.querySelector(".close-canvas-btn").dispatchEvent(new Event("click"));
      },1000)
      
    })
    .catch((error) => {
      console.error("Error uploading image:", error);
          targetBTN.setAttribute("disabled", "disabled");
          targetBTN.querySelector(".loader-button__text").classList.add("opacity-zero");
          targetBTN.querySelector(".loader-button__text").innerHTML = `Please Try Again!`;
          targetBTN.querySelector(".loader-button__loader").classList.add("opacity-one");
          targetBTN.querySelector(".loader-button__loader").classList.remove("opacity-zero");

    });

  });


 var close_canvas_btn = document.querySelector(".close-canvas-btn");
  if(close_canvas_btn){
    close_canvas_btn.addEventListener("click",(event)=>{
      const canvas = document.querySelector("#single-image-canvas");
      if(canvas){
        canvas.classList.add("make-canvas-hidden");
        canvas.classList.remove("make-canvas-visible");
      }
    })
  }


var cartData_token = null;
var part_number = 0;
var og_client_file = null;
fetch("/cart.json")
.then((res)=>{
  return res.json();
})
.then(data => {
  cartData_token = data.token;
  const cart_items = data.items;
  for (let item of cart_items) {
    const item_part_number = Number(item.properties['Part Number']);
    if(item_part_number > part_number){
      part_number = item_part_number;      
    }
  }

  if(part_number < 10){
    part_number = '0' + (part_number + 1);
  }else
  {
    part_number = part_number + 1;
  }
  // console.log(cartData_token);
})

document.querySelector(".custom-select-mlveda-artwork")?.addEventListener("change",(e)=>{
  e.target.closest(".sidebar-child-container").querySelector(".artwork-part-name").value = e.target.value;
})
